import {createAction} from 'redux-actions';

export const SET_MESSAGE = 'SET_MESSAGE';

export const setMessage =createAction(SET_MESSAGE, (message) => {
  return message
})
